:host{display:inline-block}button{font-weight:400}
/*# sourceMappingURL=/ba/public/app-notification-event-button.component.css.map */
